import { constants } from "redux/constants/redux-constants";

const initialState = {
  activeGenerations: [], // Array of { patientId, encounterId, patientName }
  showFloatingProgressWidget: false,
  refreshPatientHistory: {}, // { [patientId_encounterId]: true }
};

const ActiveSOAPGenerationReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.ACTIVE_SOAP_GENERATION.ADD_ACTIVE_SOAP_GENERATION:
      if (
        state.activeGenerations.some(
          (g) =>
            g.patientId === action.payload.patientId &&
            g.encounterId === action.payload.encounterId
        )
      ) {
        return state;
      }
      return {
        ...state,
        activeGenerations: [...state.activeGenerations, action.payload],
      };

    case constants.ACTIVE_SOAP_GENERATION.REMOVE_ACTIVE_SOAP_GENERATION:
      return {
        ...state,
        activeGenerations: state.activeGenerations.filter(
          (g) =>
            !(
              g.patientId === action.payload.patientId &&
              g.encounterId === action.payload.encounterId
            )
        ),
      };

    case constants.ACTIVE_SOAP_GENERATION.SET_SHOW_PROGRESS_BAR:
      return {
        ...state,
        showFloatingProgressWidget: action.payload,
      };

    case constants.ACTIVE_SOAP_GENERATION.CLEAR_ALL_ACTIVE_SOAP_GENERATIONS:
      return {
        ...initialState,
      };

    case constants.ACTIVE_SOAP_GENERATION.REFRESH_PATIENT_HISTORY:
      return {
        ...state,
        refreshPatientHistory: {
          ...state.refreshPatientHistory,
          [`${action.payload.patientId}_${action.payload.encounterId}`]: true,
        },
      };

    case constants.ACTIVE_SOAP_GENERATION.CLEAR_REFRESH_PATIENT_HISTORY:
      {
        const key = `${action.payload.patientId}_${action.payload.encounterId}`;
        const { [key]: _, ...rest } = state.refreshPatientHistory;
        return {
          ...state,
          refreshPatientHistory: rest,
        };
      }

    default:
      return state;
  }
};

export default ActiveSOAPGenerationReducer;
